import React from "react";
import {Box} from "@mui/material";
import {alpha, useTheme} from "@mui/material/styles";

const OPTIONS = [{value: "package", label: "Package"}, {value: "ltl", label: "LTL"}];

export const TrackingTypeSelector = ({value, onChange}) => {
    const theme = useTheme();
    return (
        <Box
            role="group"
            aria-label="Tracking type"
            sx={{
                display: "inline-flex",
                width: "auto",
                backgroundColor: alpha(theme.palette.neutral[200], 0.28),
                p: 0.25,
                borderRadius: `${theme.shape.lg}px`,
                border: 1,
                borderColor: "divider",
            }}
        >
            {OPTIONS.map((option) => {
                const isSelected = value === option.value;
                return (
                    <Box
                        key={option.value}
                        component="button"
                        type="button"
                        aria-pressed={isSelected}
                        onClick={() => onChange(option.value)}
                        sx={{
                            border: "none",
                            cursor: "pointer",
                            borderRadius: `${theme.shape.md}px`,
                            px: 1.5,
                            minWidth: {xs: 108, sm: 0},
                            minHeight: {xs: 44, sm: 36},
                            fontSize: theme.typography.subtitle2.fontSize,
                            lineHeight: theme.typography.subtitle2.lineHeight,
                            fontWeight: theme.typography.subtitle2.fontWeight,
                            fontFamily: "inherit",
                            backgroundColor: isSelected ? "background.paper" : "transparent",
                            color: isSelected ? "text.primary" : "text.secondary",
                            boxShadow: isSelected ? "0 1px 2px rgba(15, 23, 42, 0.08)" : "none",
                            transition: "background-color 150ms ease, color 150ms ease, box-shadow 150ms ease",
                            display: "flex",
                            flex: "initial",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 0.5,
                            "&:focus-visible": {outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 1},
                        }}
                    >
                        <Box aria-hidden="true" sx={{width: 6, height: 6, borderRadius: "50%", backgroundColor: isSelected ? "primary.main" : "transparent"}} />
                        {option.label}
                    </Box>
                );
            })}
        </Box>
    );
};
